<script setup lang="ts">
import { useFetch, useRoute, useRuntimeConfig } from '#app'
import CmsComponentsListBlock from '~/layers/cms/app/components/cms/CmsComponentsListBlock.vue'
import { useAuthStore } from '~/layers/cms/app/stores/authStore'
import { default_page_settings, type PageSettings } from '~/layers/cms/app/types/cmsTypes'
import { onMounted, computed, ref } from 'vue'
import Blog from '~/layouts/blog.vue'
import { getPageSettings } from '#imports'

const route = useRoute()

const config = useRuntimeConfig()
const { data } = await useFetch(`${config.public.apiBase}/api/get-page-settings`, {
  query: { slug: route.path },
  transform: response => (response ?? default_page_settings) as PageSettings,
  getCachedData: (key, nuxtApp) =>
    nuxtApp.isHydrating ? nuxtApp.payload.data[key] : undefined
})
const authStore = useAuthStore()
const newsList = ref<PageSettings>(data.value as PageSettings)

onMounted(async () => {
  if (authStore.authorized) {
    const res = await getPageSettings(route.path)
    if (res.status_ok) {
      newsList.value = res.data as PageSettings
    }
  }
})
const CurrentPageSettings = computed<PageSettings>(() => data.value ?? default_page_settings)
</script>

<template>
  <div v-if="CurrentPageSettings.group == 'aktualność'">
    <Blog>
      <CmsComponentsListBlock :cms-data-path="['data']" />
    </Blog>
  </div>
  <div v-else>
    <div class="h-18 xl:h-31.5" />
    <CmsComponentsListBlock :cms-data-path="['data']" />
  </div>
</template>
